import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { SYS4120_R01Filter } from "./Store_SYS4120_R01";
import { SYS4120_R01Dto } from "./Dto_SYS4120_R01";

const noticeUrl = `${config.apiUrl}/SYS4120_R01`;


export const getSYS4120_R01List = async ( option: string, params: Partial<SYS4120_R01Filter>, listLength: number = 0) => {
	const url = `${noticeUrl}/${option}`;

	return await getData<ResponseDto<SYS4120_R01Dto[]>>(url, { params: {
		...params,
		listLength
	} })
}

export const getSYS4120_R01AllCount = async (params: Partial<SYS4120_R01Filter>) => {
    const url = `${noticeUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}	

export const getSYS4120_R01One = async (notice_no: string) => {
	const url = `${noticeUrl}/one/${notice_no}`;

	return await getData<ResponseDto<SYS4120_R01Dto>>(url);
}


export const createSYS4120_R01 = async (data: SYS4120_R01Dto) => {

	return await postData<SYS4120_R01Dto, ResponseDto<SYS4120_R01Dto[]>>(noticeUrl, data);
}

export const patchSYS4120_R01 = async (data: SYS4120_R01Dto) => {

	return await patchData<SYS4120_R01Dto, ResponseDto<SYS4120_R01Dto[]>>(noticeUrl, data);
}

export const deleteSYS4120_R01 = async (itemCd: string) => {
	const url = `${noticeUrl}/${itemCd}`;

	return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_SYS4120_R01 = async ( option: string, params: Partial<SYS4120_R01Filter>, listLength: number = 0) => {

	const url = `${noticeUrl}/excel/${option}`;

	return await getData<ResponseDto<string>>(url, { params: {
		...params,
		listLength
	} })
}